import User from "@/menu/models/class/loginInfo/user";

export default class LoginInfoUc {
  constructor(repository) {
    this.repository = repository
  }

  async loginUserStatusUc() {
    try {
      const response = await this.repository.loginUserStatus()
      const user = User.fromJSONResponse(response.data)

      return {status: 200, user: user}
    } catch (error) {
      console.error(`error: ${error}`)
      if (error.response) {
        return {status: error.response.status, user: new User()}
      } else if (error.request) {
        return {status: 500, user: new User()}
      } else {
        return {status: 500, user: new User()}
      }
    }
  }
}
